import CustomZObject from './CustomZObject.js';

export default class MultiXYInterface extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        this.coordinates = [];
        this.numberOfCoordinates = 0;
        this.newCoordinates();
        this.newCoordinates();
        this.newOutlet("coordinates");
        this.zObject.newAttribute("x-axis", "x");
        this.zObject.newAttribute("y-axis", "y");
    }

    newCoordinates() {
        this.zObject.newAttribute("coordinate-color-" + (this.numberOfCoordinates + 1), "#ffffff");
        this.zObject.newAttribute("coordinate-name-" + (this.numberOfCoordinates + 1), "type name");
        this.coordinates[this.numberOfCoordinates] = {x: 0.5, y: 0.5};
        this.coordinates = [... this.coordinates];
        this.numberOfCoordinates++;
    }

    sendCoordinates() {
        this.sendMessage("coordinates", this.coordinates.map(c => ([c.x, c.y])));
    }

    setXY(x,y,i) {
        this.coordinates[i] = {
            x,y
        };
        this.sendCoordinates();
    }

    getJson() {
        return {
            ... super.getJson(),
            coordinates: this.coordinates,
            numberOfCoordinates: this.numberOfCoordinates
        };
    }

    fromJson(json, copy) {
        super.fromJson(json, copy);

        this.numberOfCoordinates = 2;
        this.coordinates = json.coordinates;
    }
}

